import {Component, OnInit, ViewChild} from '@angular/core';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {TranslocoService} from '@ngneat/transloco';
import {LandingComponent} from './components/landing/landing.component';
import {LoggedUser} from './common/logged-user.service';
import {TimezoneService} from './services/timezone.service';
import * as moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'frontend';
  showMenu = true;
  authenticated = false;

  @ViewChild(LandingComponent, {static: false})
  landingComponent: LandingComponent;

  constructor(private primengConfig: PrimeNGConfig,
              private translocoService: TranslocoService,
              private messageService: MessageService,
              private timezoneService: TimezoneService,
              private loggedUser: LoggedUser) {
    loggedUser.userObservable.subscribe(user => this.authenticated = user !== undefined);
  }

  ngOnInit(): void {
    this.translocoService.getTranslation('es');
    this.translocoService.setDefaultLang('es');
    this.translocoService.setActiveLang('es');
    this.primengConfig.ripple = true;
    moment.updateLocale('en', {week: {dow: 1}});
  }

  private functionVoid(): void {
  }

}
